<div class="avia-not-found">
  <div class="title">{{ filtered ? translates.notFoundByFilters : translates.notFoundTickets }}</div>
  <div class="subtitle">{{ translates.trySearch }}</div>
  <button type="button" class="btn btn-blue find-avia-btn" (click)="goToFindForm()">
    {{ filtered ? translates.changeFilters : translates.trySearchBtn }}
  </button>
</div>
